export default "__VITE_ASSET__Dgx98cvP__"